import { render, staticRenderFns } from "./MensalidadeCreate.vue?vue&type=template&id=764137a9&"
import script from "./MensalidadeCreate.vue?vue&type=script&lang=js&"
export * from "./MensalidadeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports